import $store from '../../../store/index'
import { stopLocalStream } from './createTrtcV5'
export default (camera, screen) => {
  console.log('关闭', camera, screen)
  let { timerCamera, timerErrorCamera, cameraClient, screenClient, timerScreenImg, connectClient, streamObj } = $store.state.proctor
  $store.commit('set_examCameraId', null)
  if (camera) {
    timerCamera && clearInterval(timerCamera)
    timerErrorCamera && clearInterval(timerErrorCamera)
    cameraClient && stopLocalStream(streamObj, cameraClient, 'stopLocalVideo', res => { }, e => { })
    cameraClient && stopLocalStream(streamObj, cameraClient, 'stopLocalAudio', res => { }, e => { })
    $store.commit('set_timerCamera', null)
    $store.commit('set_timerErrorCamera', null)
    $store.commit('set_cameraClient', null)
    $store.commit('set_noCameraTips', null)
    $store.commit('set_cameraStream', null)
  }
  if (screen) {
    screenClient && stopLocalStream(streamObj, screenClient, 'stopScreenShare', res => { }, e => { })
    timerScreenImg && clearInterval(timerScreenImg)
    $store.commit('set_timerScreenImg', null)
  }
  if (connectClient) {
    connectClient && stopLocalStream(streamObj, connectClient, 'stopLocalAudio', res => { }, e => { })
    $store.commit('set_connectClient', null)
    $store.commit('set_connectStream', null)
  }
}



// WEBPACK FOOTER //
// ./src/components/bloom-proctor/public/closeStream.js